import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=06763a9c&scoped=true&"
import script from "./SalesManagement.vue?vue&type=script&lang=js&"
export * from "./SalesManagement.vue?vue&type=script&lang=js&"
import style0 from "./SalesManagement.vue?vue&type=style&index=0&id=06763a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06763a9c",
  null
  
)

export default component.exports